import { AnswerToken } from './../shared/models/answer-token.model';
import { User } from './models/user';
import { Account } from './models/account';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import * as moment from 'moment';
import FakeStorage from 'fake-storage';
import CryptoJS from 'crypto-js';
import { Moment } from 'moment';
export class Auth {

	public ciphertext;
	public myStorage = new FakeStorage();
	private user: User;
	private accounts: Array<Account>;
	public static cpf = '';
	public static rememberMyUser = false;
	public static attemptsCount = 1;
	public static hasToken = false;
	public static token: string;
	public static passToken = '';
	public static definePassword: boolean;
	public static defineSignature: boolean;
	public static rules: string;
	public static acceptTerms: boolean;
	public static hasSecurityQuestions: boolean;
	public static termsText: string;
	public static tempPass: string;
	public static codigoSms: string;
	public static assinaturaEletronica: string;
	public static codigoValidacao: string;
	private static _instance: Auth;
	private static securityQuestions: any;

	constructor() {
		if (Auth._instance) {
			throw new Error('Error: Instantiation failed: Use Auth.getInstance() instead of new.');
		}

		Auth._instance = this;
	}

	public static getInstance() {
		return this._instance || (this._instance = new this());
	}

	public static setSecurityQuestions(securityQuestions: AnswerToken[]) {
		this.securityQuestions = this.EncodeAnswersBase64(securityQuestions);
	}

	public static getSecurityQuestions() {
		if (this.securityQuestions) {
			return this.securityQuestions;
		} else {
			return null;
		}
	}

	/*public static b64EncodeUnicode(str: any) {
		return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
			return String.fromCharCode(('0x' + p1) as any);
		}));
	}

		public static b64DecodeUnicode(str: any) {
		return decodeURIComponent(atob(str).split('').map(function (c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	}

	public static EncodeBase64(str: AnswerToken[]) {
		return btoa(JSON.stringify(str));
	}

	public static DecodeBase64(str: any) {
		return atob(str);
	}
	*/

	public static EncodeUnicode(str: any) {
		return encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
			return String.fromCharCode(('0x' + p1) as any);
		});
	}

	public static DecodeUnicode(str: any) {
		return decodeURIComponent(str.split('').map(function (c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	}

	public static EncodeAnswersBase64(str: AnswerToken[]) {
		str.forEach(a => { a.descricao = this.EncodeUnicode(a.descricao); });
		return btoa(JSON.stringify(str));
	}

	/**
	 * Seta a lista de contas do usuário.
	 * @param accounts Array<Account>
	 */
	public setAccountsList(accounts: Array<Account>) {

		if (Auth.rememberMyUser) {
			Cookie.set('OmniAccountsList', JSON.stringify(accounts));
		}

		this.accounts = accounts;
		this.setOnSession('OmniAccounts', JSON.stringify(accounts));
	}

	/**
	 * Retorna a lista de contas do usuário.
	 */
	public getAccountsList(): Array<Account> {

		const bytes = CryptoJS.AES.decrypt(this.getOfSession('OmniAccounts'), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
		const accounts = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

		this.accounts = JSON.parse(accounts);

		return this.accounts;
	}

	/**
	 * Seta o usuário na memória e no localStorage
	 * @param userData Objeto com todos os dados do usuário
	 */
	public setUser(userData: User) {
		userData = CryptoJS.AES.encrypt(JSON.stringify(userData), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
		this.setOnSession('OmniUser', userData);
	}

	/**
	 * Retorna o objeto do usuário do localStorage
	 */
	public getUser(): User {
		let data = this.getOfSession('OmniUser');
		if (data !== null && data !== undefined) {
			const bytes = CryptoJS.AES.decrypt(data.toString(), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
			data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
		}
		return data;
	}

	public setSessionCardNum(cardNumber: string ) {
		const number = CryptoJS.AES.encrypt(cardNumber, 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
		this.setOnSession('OmniUserCardNum', number);
	}


	public getSessionCardNum(): string {
		let data = this.getOfSession('OmniUserCardNum');
		if (data !== null && data !== undefined) {
			const bytes = CryptoJS.AES.decrypt(data.toString(), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
			data = bytes.toString(CryptoJS.enc.Utf8);
		}

		return data;
	}


	public setAttendantLogged(status) {
		this.setOnSession('AttendantLogged', true);
	}

	public getAttendantLogged(): User {
		return this.getOfSession('AttendantLogged');
	}

	/**
	 * Efetua logout, zera as variáveis e limpa o localStorage
	 */
	public logout() {
		this.accounts = null;
		// window.sessionStorage.clear();
		window.sessionStorage.removeItem('OmniAccounts');
		window.sessionStorage.removeItem('OmniUser');
		window.sessionStorage.removeItem('OmniClientAccounts');
		window.sessionStorage.removeItem('AttendantLogged');
		window.sessionStorage.removeItem('loadedPixClaimKeyData');
		window.sessionStorage.removeItem('OmniUserCardNum');
		window.sessionStorage.removeItem('bannerClosed');
		window.sessionStorage.removeItem('_OmniSummarizedSent');
	}

	getGUID(): any {
		return this.getOfSession('OmniGUID');
	}

	setGUID(GUID) {
		this.setOnSession('OmniGUID', GUID);
	}

	setOnSession(key, value) {
		if (key === 'OmniAccounts') {
			value = CryptoJS.AES.encrypt(JSON.stringify(value), 'c4870d7118605e5ec65f42a7e36972fa005828e78a58c12dc01b2976ea0c8f96');
		}
		window.sessionStorage.setItem(key, value);
	}

	getOfSession(key): any {
		return window.sessionStorage.getItem(key);
	}

	removeOfSession(key) {
		window.sessionStorage.removeItem(key);
	}

	blockLogin(blockDate) {
		this.setOnSession('OmniBUser',  blockDate);
	}

	getBlockLoginTime() {

		return this.getOfSession('OmniBUser');
	}

	unblockLogin() {
		this.removeOfSession('OmniBUser');
	}

	getLastActivity() {
		let last = this.getOfSession('OmniLastActivity');
		if (last) {
			last = moment(last);
		} else {
			last = moment().subtract(1, 'days');
		}
		return last;
	}

	recordLastActivity(activityDate: Moment) {
		this.setOnSession('OmniLastActivity', activityDate);
	}

	removeLastActivity() {
		this.removeOfSession('OmniLastActivity');
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/Auth.ts